import React, { useContext, useState } from "react";
import "./Set_New_Password.css";
import { Form } from "react-bootstrap";
import White_Btn from "../common_components/common_btn/white_btn/White_Btn";
import Blue_White_Gradient_Btn from "../common_components/common_btn/blue_white_gradient_btn/Blue_White_Gradient_Btn";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import PasswordChecklist from "react-password-checklist";
import Successfull_Modal from "../common_components/common_modal/successfull_modal/Successfull_Modal";
import classNames from "classnames";
import { forgetPassword } from "../../utils/apis/login/Login";
import { useLocation } from "react-router-dom";
import { Context } from "../../utils/context";

const Set_New_Password = () => {
  const location = useLocation();
  const email = location.state?.email; // Retrieve the email from the state


  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const navigate = useNavigate("");
  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  const [modalShow, setModalShow] = useState(false);

  const { userdata, getuserData } = useContext(Context);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      email,
    };

    const res = await forgetPassword(payload);
    if (res?.success) {
      setModalShow(true);
      getuserData(userdata?.id);
      setTimeout(() => {
        navigate("/login"); // Redirect to the home page
        setModalShow(false);
      }, 3000);
    } else {
      setError("otp", { message: res?.message });
    }
  };

  return (
    <section className="Set_New_Password Login_Signup">
      <div className="container">
        <div className="tab_container">
          <div className="login_tab_div">
            <p className="heading_title">Set New Password</p>

            <Form className="login_form" onSubmit={handleSubmit(onSubmit)}>
              <div className="outer_form_div">
                <Form.Group className="custom_form_group password_holder">
                  <Form.Label className="black_input_label">
                    New Password
                  </Form.Label>
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    name="new_password"
                    placeholder="Enter New Password"
                    {...register("new_password", {
                      required: "New Password is required",
                      minLength: {
                        value: 8,
                        message: "Password must be at least 8 characters long",
                      },
                      pattern: {
                        value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                        message:
                          "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                      },
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.new_password,
                      "is-valid": getValues("new_password"),
                    })}
                  />
                  <div className="eye-icc">
                    <FontAwesomeIcon
                      icon={iconOne}
                      className="eye-icon"
                      onClick={() => togglePasswordVisibility("password")}
                    />{" "}
                  </div>

                </Form.Group>
                {errors?.new_password && (
                  <div className="mt-md-0 mt-sm-3 mt-3">
                    <sup className="text-danger  ">
                      {errors?.new_password?.message}
                    </sup>
                  </div>
                )}
              </div>

              <div className="outer_form_div">
                <Form.Group className="custom_form_group password_holder">
                  <Form.Label className="black_input_label">
                    Confirm Password
                  </Form.Label>
                  <Form.Control
                    type={showPasswordOne ? "text" : "password"}
                    name="confirm_password"
                    placeholder="Confirm New Password"
                    {...register("confirm_password", {
                      required: "Confirm Password is required",
                      validate: (value) =>
                        value === getValues("new_password") ||
                        "Passwords do not match",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.confirm_password,
                      "is-valid": getValues("confirm_password"),
                    })}
                  />
                  <div className="eye-icc">
                    <FontAwesomeIcon
                      icon={iconTwo}
                      className="eye-icon"
                      onClick={() => togglePasswordVisibility("reenterPassword")}
                    />
                  </div>

                </Form.Group>
                {errors?.confirm_password && (
                  <div className="mt-md-0 mt-sm-3 mt-3">
                    <sup className="text-danger  ">
                      {errors?.confirm_password?.message}
                    </sup>
                  </div>
                )}
              </div>

              <div className="form_footer">
                <div className="continue_btn">
                  <Blue_White_Gradient_Btn
                    btn_name="Continue"
                    onClick={handleSubmit(onSubmit)}
                  />
                </div>
                <div className="continue_btn mt-3">
                  <White_Btn
                    btn_name="Back"
                    onClick={() => {
                      navigate("/verify-email");
                    }}
                  />
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <Successfull_Modal
        message="Password Updated Successfully"
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </section>
  );
};

export default Set_New_Password;
